
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import Head from 'next/head';
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import styles from './index.module.scss';
import Layout from '../../components/Layout';
import { Namespace } from '../../enums/namespaces';
import { StaticPathParams } from '../../typings/staticPaths';
import { FAQList } from 'components';
import { basicSEO } from 'helpers/jsx';
import { useAuth, withForcePlanToLoggedInUnsubs } from 'context';
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import { createRedirectIfNeeded } from 'helpers';
import prices from 'config/prices';
import { Country } from 'enums/country';

interface Props {
  priceMonthly: string;
  priceYearly: string;
  priceYearlyDiscount: string;
  countryCode: string;
}

const FAQ: NextPage<Props> = ({ priceMonthly, priceYearly, priceYearlyDiscount, countryCode }: Props) => {
  const { t } = useTranslation(Namespace.FAQ);

  return (
    <Layout countryCode={countryCode}>
      <Head>
        {basicSEO(t('seo:frequently_asked_questions_title'), t('seo:frequently_asked_questions_description'))}
      </Head>
      <main className={styles.faq}>
        <div className={styles.faqWrapper}>
          <h1>{t('title')}</h1>
          <FAQList
            priceMonthly={priceMonthly}
            priceYearly={priceYearly}
            priceYearlyDiscount={priceYearlyDiscount}
            countryCode={countryCode}
          />
          <p className={styles.more}>
            {t('know_more')}{' '}
            <a href="mailto:support@dramox.tv" target="_blank">
              {(() => {
                switch (countryCode) {
                  case Country.Czechia:
                    return 'napoveda@dramox.cz';
                  case Country.Slovakia:
                    return 'napoveda@dramox.cz';
                  case Country.Ukraine:
                    return 'pidtrymka@dramox.tv';
                  default:
                    return 'support@dramox.tv';
                }
              })()}
            </a>
            .
          </p>
        </div>
      </main>
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { locale, apiClient, countryCode } = await authorizeUserServerSide(ctx);

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  const plans = await apiClient.getPlans();

  let priceMonthly: string;
  let priceYearly: string;
  let priceYearlyDiscount: string;
  const planMonthly = plans.find((p) => p.recurrence.unit === 'MONTH' && p.recurrence.length === 1);
  const planYearly = plans.find((p) => p.recurrence.unit === 'YEAR' && p.recurrence.length === 1);

  if (planMonthly && planYearly) {
    priceMonthly = planMonthly.price.formatted;
    priceYearly = planYearly.price.formatted;
    const currency = planYearly.price.currency;
    priceYearlyDiscount = priceMonthly
      .replace(',', '.')
      .replace('0', '')
      .replace(planMonthly.price.value.toString(), prices[currency].yearPriceDiff.toString());
  }

  return {
    props: {
      priceMonthly,
      priceYearly,
      priceYearlyDiscount,
      countryCode,
    },
  };
}

export default withForcePlanToLoggedInUnsubs(FAQ);


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/frequently-asked-questions/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  